import { ADMINBLOG_CREATE_ACTIONS, BLOG_DELETE_ACTIONS, BLOG_UPDATE_ACTIONS, GET_ALLBLOG_ACTIONS } from "../../../actionType/admin/blog";


const intialState = {
  blogPostCreatData: {},
  blogPostCreateLoader: false,
  blogPostList: {},
  isBlogPostListLoader: false,
  blogUpdate: {},
  isBlogUpdate: false,
  blogDelete: {},
  isBlogDeleteLoad: false,

};
export const adminBlogReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMINBLOG_CREATE_ACTIONS.ADMINBLOG_CREATE_REQUEST:
      return { ...state, blogPostCreateLoader: true };
    case ADMINBLOG_CREATE_ACTIONS.ADMINBLOG_CREATE_RESPONSE:
      return {
        ...state,
        blogPostCreatData: payload,
        blogPostCreateLoader: false,
      };
    case ADMINBLOG_CREATE_ACTIONS.ADMINBLOG_CREATE_ERROR:
      return {
        ...state,
        blogPostCreatData: payload,
        blogPostCreateLoader: false,
      };

    //GET ALL BLOG POST
    case GET_ALLBLOG_ACTIONS.GET_ALLBLOG_REQUEST:
      return { ...state, isBlogPostListLoader: true };
    case GET_ALLBLOG_ACTIONS.GET_ALLBLOG_RESPONSE:
      return {
        ...state,
        blogPostList: payload,
        isBlogPostListLoader: false,
      };
    case GET_ALLBLOG_ACTIONS.GET_ALLBLOG_ERROR:
      return {
        ...state,
        blogPostList: payload,
        isBlogPostListLoader: false,
      };
    //UPDATE BLOG POST
    case BLOG_UPDATE_ACTIONS.BLOG_UPDATE_REQUEST:
      return { ...state, isBlogUpdate: true };
    case BLOG_UPDATE_ACTIONS.BLOG_UPDATE_RESPONSE:
      return {
        ...state,
        blogUpdate: payload,
        isBlogUpdate: false,
      };
    case BLOG_UPDATE_ACTIONS.BLOG_UPDATE_ERROR:
      return {
        ...state,
        blogUpdate: payload,
        isBlogUpdate: false,
      };
    //UPDATE BLOG POST
    case BLOG_DELETE_ACTIONS.BLOG_DELETE_REQUEST:
      return { ...state, isBlogDeleteLoad: true };
    case BLOG_DELETE_ACTIONS.BLOG_DELETE_RESPONSE:
      return {
        ...state,
        blogDelete: payload,
        isBlogDeleteLoad: false,
      };
    case BLOG_DELETE_ACTIONS.BLOG_DELETE_ERROR:
      return {
        ...state,
        blogDelete: payload,
        isBlogDeleteLoad: false,
      };

    default:
      return state;
  }
};